module.exports = __webpack_public_path__ + "static/media/eccv_long_corrected_v3.8b307696.mp4";